import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";
import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  cell: {
    width: "100%",
    height: "initial",
    lineHeight: "normal",
    textAlign: "left"
  },
  employee: {
    padding: "15px",
    paddingLeft: "0px",
  },
}));

const EmployeeCell = (props) => {
  const classes = useStyles();

  const renderEmployee = (emp) => {
    return emp.employeeLastName + ", " + emp.employeeFirstName + " (" + emp.employeeId + ") - " + emp.employeeWorkgroup;
  };

  return (
    <div className={classes.cell} data-testid="employee-cell">
      <div className={classes.employee}>{renderEmployee(props.empOne)}</div>
      <Divider />
      <div className={classes.employee}>{renderEmployee(props.empTwo)}</div>
    </div>
  );
};

EmployeeCell.propTypes = {
  empOne: PropTypes.object.isRequired,
  empTwo: PropTypes.object.isRequired,
};

export default EmployeeCell;
